export const LIGNE_ROB_COM_RESET = "LIGNE_ROB_COM_RESET";
export const LIGNE_ROB_COM_SET_ERROR = "LIGNE_ROB_COM_SET_ERROR";
export const LIGNE_ROB_COM_SET_ITEMS = "LIGNE_ROB_COM_SET_ITEMS";
export const LIGNE_ROB_COM_TOGGLE_LOADING = "LIGNE_ROB_COM_TOGGLE_LOADING";
